import moment from 'moment';
import momenttz from 'moment-timezone';

export const formatDate = dateISOString => {
  return moment(dateISOString).format('M/D/YYYY');
};

export const formatTime = dateISOString => {
  return moment(dateISOString).format('h:mm A');
};